import * as emoji from "node-emoji";

function limpiarTexto(texto) {
  return (texto || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ") // reemplaza múltiples espacios por uno solo
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, ""); // quita acentos
}

function obtenerEmoji(especie, variedad, emojiDict) {
  const limpiar = limpiarTexto;
  const e = limpiar(especie);
  const v = limpiar(variedad);
  const ev = `${e} ${v}`.trim();

  const buscarEmojiValido = (clave) => {
    if (!clave) return null;
    const raw = emojiDict[clave];
    if (!raw) return null;

    const nombreEmoji = raw.replace(/:/g, "");
    const emojiChar = emoji.get(nombreEmoji);
    // Si el nombre es inválido, node-emoji devuelve ":nombre:"
    return emojiChar === `:${nombreEmoji}:` ? null : emojiChar;
  };

  const intentos = [ev, v, e];
  for (const intento of intentos) {
    const encontrado = buscarEmojiValido(intento);
    if (encontrado) return encontrado;
  }

  // Búsqueda por coincidencia parcial
  const claveCoincidente = Object.keys(emojiDict).find((key) => {
    const keyLimpia = limpiar(key);
    return keyLimpia.includes(ev) || keyLimpia.includes(v) || keyLimpia.includes(e);
  });

  if (claveCoincidente) {
    const encontrado = buscarEmojiValido(claveCoincidente);
    if (encontrado) return encontrado;
  }

  return "❓";
}

function capitalize(str = "") {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export class Fila {
  constructor(data, emojiDict = {}) {
    this.especie = data.Especie || "";
    this.variedad = data.Variedad || "";
    this.etiqueta = data.Etiqueta || "";
    this.calidad = data.Calidad || "";
    this.Dif = data.Dif || "";
    this.calibre = data.Calibre || "";
    this.empaque = data.Empaque || "";
    this.presentacion = data.Presentación || "";
    this.serieLote = data.SerieLote || "";
    this.diasEntrada = data["Días entrada"] || "";
    this.articulo = data.Artículo || "";
    this.mayoreo = parseFloat(data.Mayoreo) || 0;
    this.menudeo = this.mayoreo + 20;
    this.precioEspecial = parseFloat(data["Precio Especial"]) || 0;
    this.transito = data.Transito || "";
    this.costeo = data.Costeo || "";
    this.gdl = data.GDL || "";
    this.mex = data.MEX || "";
    this.mxl = data.MXL || "";
    this.estatus = data.Estatus || "";

    // Emoji asociado a especie + variedad
    this.emoji = obtenerEmoji(this.especie, this.variedad, emojiDict);
  }

  titulo() {
    return `OC ${this.serieLote} ${capitalize(this.especie)} ${this.emoji} ${this.etiqueta}`;
  }

  detalles() {
    const especial = this.precioEspecial ? ` / *Precio especial: $${this.precioEspecial}*` : "";
    return `${this.transito} cjs - ${this.calibre} ${this.calidad} ${this.Dif} ${this.empaque} ${this.variedad} $${this.mayoreo}${especial}`;
  }

  toJson() {
    return {
      especie: this.especie,
      variedad: this.variedad,
      etiqueta: this.etiqueta,
      calidad: this.calidad,
      Dif: this.Dif,
      calibre: this.calibre,
      empaque: this.empaque,
      presentacion: this.presentacion,
      serieLote: this.serieLote,
      diasEntrada: this.diasEntrada,
      articulo: this.articulo,
      mayoreo: this.mayoreo,
      menudeo: this.menudeo,
      precioEspecial: this.precioEspecial,
      transito: this.transito,
      costeo: this.costeo,
      gdl: this.gdl,
      mex: this.mex,
      mxl: this.mxl,
      estatus: this.estatus,
      emoji: this.emoji,
    };
  }
}
